import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import Link from '@UI/Link';
import PopupOnMap from '../PopupOnMap';
import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';
import styles from './PopupAllSellPoints.module.css';

import type { SellPointDataSearch } from '@Types/SellPointsSearch';
import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { SellPointData } from '@Types/SellPoints';

export interface PopupAllSellPointsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  sellPoints: SellPointDataSearch[] | SellPointData[];
  infoText?: string;
  onMore?: (e: MouseEvent, sellPoint: SellPointDataSearch) => void;
  searchParamsValue?: string;
  onChangeParams?: (params: string) => void;
}

const PopupAllSellPoints: FC<PopupAllSellPointsProps> = (props) => {
  const {
    className,
    sellPoints,
    onMore,
    infoText,
    searchParamsValue,
    onChangeParams,
    ...restProps
  } = props;
  const { t } = useTranslation();

  const handleMore = useCallback(
    (e, sellPoint) => {
      if (onMore) onMore(e, sellPoint);
    },
    [onMore],
  );

  return (
    <PopupOnMap
      {...restProps}
      title={t('ui.map.title')}
      onChangeParams={onChangeParams}
      className={className}
      hasSearch
      searchParamsValue={searchParamsValue}
      infoText={infoText}
    >
      {sellPoints.map((sellPoint, index) => (
        <div key={sellPoint.id} className={styles.item} onClick={(e) => handleMore(e, sellPoint)}>
          <Img src={sellPoint.image} className={styles.pointIcon} />

          <div className={styles.pointInfo} data-testid='showroom-shop'>
            <Link className={styles.head}>
              <div
                className={styles.name}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: sellPoint.name }}
              />
              <div className={styles.arrow}></div>
            </Link>
            <div
              className={cn(styles.pointAddress, styles.truncated)}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: sellPoint.address }}
            />
            <div
              className={styles.underline}
              style={{ opacity: index === sellPoints.length - 1 ? 0 : 1 }}
            ></div>
          </div>
        </div>
      ))}
    </PopupOnMap>
  );
};

export default memo(PopupAllSellPoints);
